import { AxiosError } from 'axios';
import {
  AssemblyModalities,
  AssemblyType,
  SituationValues,
} from 'helpers/enums/Assembleia';
import { ExtraQueryParams } from 'helpers/utils/reactQuery';

export type ReportQueryParams = {
  url: string;
  id: string;
  fileNamePrefix: string;
  queryKey: string;
  isPdf?: boolean;
  method?: 'GET' | 'POST';
  extra?: ExtraQueryParams<any>;
};

export enum ReportType {
  CONVOCATION = 'CONVOCATION',
  EVENT_SURVEY = 'EVENT_SURVEY',
  PRESENCE = 'PRESENCE',
  PRESENCE_PDF = 'PRESENCE_PDF',
  VOTING = 'VOTING',
  QUORUM = 'QUORUM',
  EVENT = 'EVENT',
  MESSENGER = 'MESSENGER',
  GUEST = 'GUEST',
}

export enum ReportStatus {
  GENERATING = 'GENERATING',
  NOT_AVAILABLE = 'NOT_AVAILABLE',
  READY = 'READY',
  ERROR = 'ERROR',
}

export type ReportTypes = {
  reportType: ReportType;
  allowGenerate: boolean;
  reportData?: {
    lastLdap: string;
    lastDate: string;
    nextDate: string;
    version: number;
    status: ReportStatus;
  } | null;
};

export type ResponseData = {
  data: ArrayBuffer;
  fileName: string;
};

export type HandleDownloadResponseParams = {
  response: { data: ResponseData } | undefined;
  isError: boolean;
  error: AxiosError<Error> | null;
};

export type ReportInfoPage = {
  id: number;
  title: string;
  modality: AssemblyModalities;
  status: SituationValues;
  typeAcronym: AssemblyType;
  type: string;
  city: string;
  address: string;
  startDate: string;
};
